'use client';

import React, { FC } from 'react';

import Image from '@/components/core/Image';
import { useTranslation } from '@/hooks/useTranslations';
import VigensAvatar from '@/public/assets/Images/vb-avatar1.png';

import './styles.scss';

const BadalyansAI: FC = () => {
  const handleClick = () => {
    window.$hoory.toggle('show');
  };
  const { t } = useTranslation();

  return (
    <div className="bigContent badalyans-ai">
      <div className="info-container">
        <div className="image-block">
          <Image src={VigensAvatar} alt="" />
        </div>
        <div className="description-block">
          <h1 className="title">Vigen Badalyan</h1>
          <p className="subtitle">Co-Founder of SoftConstruct</p>
          <p className="description">{t('VigenBadalyan-Description')}</p>
          <button
            onClick={handleClick}
            className="button btnTypeBig btnTypeOrange start-chat-button"
          >
            <h2>{t('VigenBadalyan-Button-Chatnow')}</h2>
            <i className="bc-i-go-to btnIcon btnIconSmall" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default BadalyansAI;
